var _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 32.6668V37.3335H23.833V39.6668H16.833V32.6668H19.1663ZM40.1663 32.6668V39.6668H33.1663V37.3335H37.833V32.6668H40.1663ZM23.2497 22.1668C23.2497 23.5592 23.8028 24.8946 24.7874 25.8791C25.7719 26.8637 27.1073 27.4168 28.4997 27.4168C29.8921 27.4168 31.2274 26.8637 32.212 25.8791C33.1966 24.8946 33.7497 23.5592 33.7497 22.1668H36.083C36.0833 23.5545 35.7028 24.9156 34.983 26.1019C34.2632 27.2882 33.2317 28.2543 32.0008 28.895L31.9997 36.1668H24.9997V28.8962C23.7684 28.2556 22.7365 27.2894 22.0165 26.1028C21.2965 24.9162 20.916 23.5548 20.9163 22.1668H23.2497ZM28.4997 19.8335C29.2732 19.8335 30.0151 20.1408 30.5621 20.6878C31.109 21.2347 31.4163 21.9766 31.4163 22.7502C31.4163 23.5237 31.109 24.2656 30.5621 24.8126C30.0151 25.3595 29.2732 25.6668 28.4997 25.6668C27.7261 25.6668 26.9843 25.3595 26.4373 24.8126C25.8903 24.2656 25.583 23.5237 25.583 22.7502C25.583 21.9766 25.8903 21.2347 26.4373 20.6878C26.9843 20.1408 27.7261 19.8335 28.4997 19.8335ZM23.833 16.3335V18.6668L19.1663 18.6657V23.3335H16.833V16.3335H23.833ZM40.1663 16.3335V23.3335H37.833V18.6668H33.1663V16.3335H40.1663Z",
    fill: "#F2994A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 0.5,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#F2994A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/Icon_person.369d1e644800be12465c11d093f12e94.svg";
export { ForwardRef as ReactComponent };